import React, { useState } from 'react';
import { Modal, Button, Badge, Row, Col } from 'react-bootstrap';


// Sample order data
const orders = [
    {
        id: 'AD01274300378CIN',
        date: 'Monday, 14th June 2025 | 3:45PM',
        deliverydate: 'Wednesday, 17th June 2025 | 3:45PM',
        package: 'YouTube Insta TikTok Videos',
        price: '€54.99',
        type: 'Basic Cut and Audio',
        duration: '5 minutes',
        status: 'Delivered',
    },
    {
        id: 'AD01274300378CIO',
        date: 'Wednesday, 17th June 2025 | 2:45PM',
        deliverydate: 'Thursday, 18th June 2025 | 3:45PM',
        package: 'Podcast Editing',
        price: '€34.99',
        type: 'Podcast editing with intro and outro',
        duration: '20 minutes',
        status: 'Processing',
    },
    {
        id: 'AD01274300378DEL',
        date: 'Friday, 19th June 2025 | 11:00AM',
        deliverydate: 'Sunday, 21st June 2025 | 6:30PM',
        package: 'Travel Vlog',
        price: '€64.99',
        type: 'Color grading and transitions',
        duration: '10 minutes',
        status: 'Delivered',
    },
    {
        id: 'AD01274300378REV',
        date: 'Saturday, 20th June 2025 | 4:00PM',
        deliverydate: 'Monday, 22nd June 2025 | 3:00PM',
        package: 'Music Video',
        price: '€89.99',
        type: 'Premium editing with motion graphics',
        duration: '8 minutes',
        status: 'Revision',
    },
    {
        id: 'AD01274300378NEW',
        date: 'Sunday, 21st June 2025 | 1:30PM',
        deliverydate: 'Tuesday, 23rd June 2025 | 5:00PM',
        package: 'Event Highlights',
        price: '€74.99',
        type: 'Highlight cuts and audio mixing',
        duration: '12 minutes',
        status: 'Processing',
    },
    {
        id: 'AD01274300378WED',
        date: 'Monday, 22nd June 2025 | 10:00AM',
        deliverydate: 'Wednesday, 24th June 2025 | 8:00PM',
        package: 'Wedding Video',
        price: '€149.99',
        type: 'Full edit with transitions and effects',
        duration: '30 minutes',
        status: 'Delivered',
    },
];


const OrderList = () => {
    const [showOrderDetails, setShowOrderDetails] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [statusFilter, setStatusFilter] = useState('All');

    const handleShowDetails = (order) => {
        setSelectedOrder(order);
        setShowOrderDetails(true);
    };

    const handleCloseDetails = () => {
        setShowOrderDetails(false);
        setSelectedOrder(null);
    };

    const getStatusVariant = (status) => {
        switch (status) {
            case 'Delivered':
                return 'success';
            case 'Processing':
                return 'warning';
            case 'Revision':
                return 'danger';
            default:
                return 'secondary';
        }
    };

    return (
        <div className="order-list">
            <Row>
                <Col md={6} xs={12} className='filter-heading'>
                    <h5>My Orders</h5>
                </Col>
                <Col md={6} xs={12}>
                    <div className="d-flex justify-content-end mb-3">
                        <select
                            className="form-select w-auto filter-select"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                        >
                            <option value="All">All</option>
                            <option value="Delivered">Delivered</option>
                            <option value="Processing">Processing</option>
                            <option value="Revision">Revision</option>
                        </select>
                    </div>
                </Col>
            </Row>

            {orders
                .filter(order => statusFilter === 'All' || order.status === statusFilter)
                .map((order, index) => (
                    <div key={index} className="order-item">
                        <div className="order-info">
                            <div><strong>Order Id:</strong> {order.id}</div>
                            <div><strong>Date:</strong> {order.date}</div>
                            <Button
                                variant="secondary"
                                size="sm"
                                className="mt-2"
                                onClick={() => handleShowDetails(order)}
                            >
                                Show Details
                            </Button>
                        </div>
                        <div className="order-action">
                            <div>
                                <Badge bg={getStatusVariant(order.status)}>{order.status}</Badge>
                            </div>
                            <div className="order-price">
                                <span>{order.price}</span>
                            </div>
                        </div>
                    </div>
                ))}

            {/* Order details modal */}
            {selectedOrder && (
                <Modal show={showOrderDetails} onHide={handleCloseDetails} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Order Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='order-details'>
                            <ul>
                                <li>
                                    <label>Order ID :</label>
                                    <span>{selectedOrder.id}</span>
                                </li>
                                <li>
                                    <label>Ordered on :</label>
                                    <span>{selectedOrder.date}</span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <label>Delivered on :</label>
                                    <span>{selectedOrder.deliverydate}</span>
                                </li>
                            </ul>
                            <div className='packege'>
                                <p><strong>Video Type :</strong> {selectedOrder.type}</p>
                                <p><strong>Package :</strong> {selectedOrder.package}</p>
                                <p><strong>Duration :</strong> {selectedOrder.duration}</p>
                                <p>
                                    <strong>Status:</strong>{' '}
                                    <Badge bg={getStatusVariant(selectedOrder.status)}>
                                        {selectedOrder.status}
                                    </Badge>
                                </p>
                            </div>

                            <div className='total'>
                                <label><strong>Total Price :</strong></label>
                                <span>{selectedOrder.price}</span>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </div>
    );
};

export default OrderList;
